import {set, toCamelCase} from '@exadel/esl/modules/esl-utils/misc';
import {unwrap} from 'core/helpers/dom';


/**
 * Convert string attribute value to the most proper deserialized value (boolean, number, object, string)
 * @param value - attribute value
 * */
export const parseAttrValue = (value: string): any => {
  value = String(value).trim();
  if (value === 'true' || value === '') return true;
  if (value === 'false') return false;
  if (!isNaN(+value)) return +value;
  if (value[0] === '{' && value[value.length - 1] === '}') {
    try {
      return Function(`return ${value};`)();
    } catch { /* Nothing bad, assume that it was object but it is not */ }
  }
  return value;
};

const bindDataAttr = (attr: string, value: any, attrs: Record<string, any>) => {
  value = typeof value === 'string' ? parseAttrValue(value) : value;
  set(attrs, attr.split('--').map(toCamelCase).join('.'), value);
};

/**
 * Parse data attrs on the element
 * Format: data-tabs-trigger-el=".js-trigger" data-tabs-events--show-event = "tabs.on.show"
 * parseDataAttrs(el, 'tabs'); will be transformed into:
 * {
 *  'triggerEl': '.js-trigger',
 *  'events': {
 *    'showEvent': 'tabs.on.show'
 *  }
 * }
 */
export function parseDataAttrs(el: JQuery | HTMLElement, prefix: string = '', attrMapping: Record<string, string> = {}) {
  const domEl = unwrap(el);
  const dataAttrs = {};
  const dataAttrPrefix = prefix ? `data-${prefix}-` : 'data-';
  Array.from(domEl.attributes).forEach(({nodeName, nodeValue}) => {
    if (attrMapping[nodeName]) {
      bindDataAttr(attrMapping[nodeName], nodeValue, dataAttrs);
    } else if (nodeName.indexOf(dataAttrPrefix) === 0) {
      const attrName = nodeName.slice(dataAttrPrefix.length);
      bindDataAttr(attrName, nodeValue, dataAttrs);
    }
  });
  const classList = domEl.classList;
  Object.keys(attrMapping)
    .filter((key) => key.indexOf('.') === 0)
    .forEach((key) => bindDataAttr(attrMapping[key], classList.contains(key.slice(1)), dataAttrs));
  return dataAttrs;
}
